export default __webpack_public_path__ + "static/media/Marcelino Dias_.62b30a19.png";